<div id="list-insurance" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.LISTING_INSURANCE" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                </div>
            </div>
            <div class="form-group row mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="filterPolicyForm"
                    (ngSubmit)="submitFilterPolicy(loadingModal)"
                    >
                        <div class="row mb-3">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.BY_POLICY_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputNroDePoliza" name="inputNroDePoliza">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.YEAR" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo">
                                                <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                                <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="sr-only">{{ "INPUT.MONTH" | translate }}</label>
                                            <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes">
                                                <option value="">{{ "INPUT.MONTH" | translate }}</option>
                                                <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.CATEGORY" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputRamo" name="inputRamo" (change)="changeRamo($event)">
                                        <option value="">{{ "INSURANCE.CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of ramos | async" value="{{item.IdRamo}}">{{item.Ramo}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INSURANCE.SUB_CATEGORY" | translate }}</label>
                                    <select class="form-control" formControlName="inputSubRamo" name="inputSubRamo" ng-disabled="!IdRamo">
                                        <option value="">{{ "INSURANCE.SUB_CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of subramos | async" value="{{item.IdSubRamo}}">{{item.SubRamo}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.FIRSTNAME" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.FIRSTNAME' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                </div>
                            </div>

                            <!--div class="col-md-2">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.PERSONID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.PERSONID' | translate }}" formControlName="inputIdentificacion" name="inputIdentificacion">
                                </div>
                            </div -->

                            <div class="col-md-2"  *ngIf="config.IdMostrarTablilla==1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.CARID" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.CARID' | translate }}" formControlName="inputPlaca" name="inputPlaca">
                                </div>
                            </div>

                            <div class="col-md-2" *ngIf="permissionMenu.VerGrupoEconomico == 1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.ECONOMICGROUP" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'INPUT.ECONOMICGROUP' | translate }}" formControlName="inputGrupoEconomico" name="inputGrupoEconomico">
                                </div>
                            </div>

                            <div class="col-md-3" *ngIf="permissionMenu.VerCompania == 1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "INPUT.COMPANIES" | translate }}</label>
                                    <select class="form-control" placeholder="" formControlName="inputIdCompania" name="inputIdCompania">
                                        <option value="">{{ "INPUT.COMPANIES" | translate }}</option>
                                        <option *ngFor="let item of companies | async" value="{{item.IdCompania}}">{{item.Compania}}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group mb-0">
                                    <button [disabled]="activeSubmitFilterPolicy" type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b my-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th width="20%" class="text-light">
                            {{ "INSURANCE.INSURED" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.SUB_CATEGORY" | translate }}
                        </th>
                        <th class="text-light" *ngIf="permissionMenu.VerCompania == 1">
                            {{ "INSURANCE.COMPANY" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.NUM_POLICY" | translate }}
                        </th>
                        <th width="5%">
                            {{ "INSURANCE.START_DATE" | translate }}
                        </th>
                        <th width="5%">
                            {{ "INSURANCE.DUE_DATE" | translate }}
                        </th>
                        <th *ngIf="showComapnyName">
                            {{ "INSURANCE.COMPANY" | translate }}
                        </th>
                        <th width="5%" *ngIf="permissionMenu.VerComision == 1">
                            {{ "INPUT.SALESCOMISSION" | translate }}
                        </th>
                        <th width="5%" *ngIf="permissionMenu.VerComisionAgente == 1">
                            {{ "INPUT.AGENTCOMISSION" | translate }}
                        </th>
                        <th>{{"INSURANCE.STATUS" | translate }}</th>
                        <th colspan="2" width="15%">{{ "INSURANCE.OPTIONS" | translate }}</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let policy of insuranceService.items$ | async; let i = index">
                            <td>{{ policy.Asegurado }}</td>
                            <td>{{ policy.SubRamo }}</td>
                            <td *ngIf="permissionMenu.VerCompania == 1"
                            >{{ policy.Aseguradora }}</td>
                            <td>{{ policy.NroDePoliza }}</td>
                            <td>{{ policy.VigenciaDesde | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ policy.VigenciaHasta | date: 'MM/dd/yyyy' }}</td>
                            <td *ngIf="showComapnyName"></td>
                            <td *ngIf="permissionMenu.VerComision == 1" >{{ policy.PorcentajeComision }}%</td>
                            <td *ngIf="permissionMenu.VerComisionAgente == 1" >{{ policy.PorcentajeComisionAgente }}%</td>
                            <td >{{ policy.Estatus }}</td>
                            <td>
                                <button type="button" class="btn pl-1 pr-1" (click)="clickView(policy.IdPoliza, 2)" data-toggle="tooltip" title='{{ "INPUT.VIEW" | translate }}'><i class="fa fa-shield-alt"></i></button>
                                <button *ngIf="permissionMenu.VerSolicitudEndosos == 1" type="button" class="btn pr-1" (click)="clickGetEndoso(endosoModal, policy.IdPoliza)" data-toggle="tooltip" title='{{ "INPUT.ENDOSOVIEW" | translate }}'><i class="fas fa-pen-alt"></i></button>
                                <button *ngIf="_user.role == 2" type="button" class="btn pr-1" (click)="clickDownloadEstatement(loadingModal, policy.IdPoliza)"  data-toggle="tooltip" title='{{ "GENERAL.ACCOUNT_ESTATEMENTS" | translate }}'><i class="fa fa-file-alt"></i></button>
                            </td>
                        </tr>

                        <tr *ngIf="!(insuranceService.items$ | async)?.length">
                            <td colspan="11">
                                <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--
            <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
                [isLoading]="isLoading" (paginate)="paginate($event)"></app-paginator>-->
        </div>
    </div>
</div>

<div id="view-insurance" *ngIf="templateView==2">
    <div class="row mt-5">
        <div class="col-md-6 col-sm-12">
            <h2 class="font-weight-bolder">
                <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.POLICY_VIEW" | translate }}
            </h2>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <button type="button" (click)="clickView(idPoliza, 3)" class="btn btn-lg btn-block btn-success font-uppercase font-weight-bolder">{{ "INSURANCE.INSURED_INTEREST" | translate }}</button>
                </div>
                <div class="col-md-6 col-sm-12">
                    <button type="button" (click)="clickView(idPoliza, 1)" class="btn btn-lg btn-block btn-default font-uppercase font-weight-bolder text-dark-65"><i class="fa fa-chevron-left"> </i>{{ "INPUT.RETURN_TO_LIST" | translate }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        <div class="card-body py-0 px-0">
            <div class="row mx-5 my-5">
                <div class="col-md-3">
                    <div><span class="font-size-h5 text-light">{{ "INSURANCE.NUM_POLICY" | translate }}</span></div>
                    <div><span class="font-size-h6 font-weight-bold">{{policy_selected.NroDePoliza}}</span></div>
                </div>

                <div class="col-md-3">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.CATEGORY" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Ramo}}</span>
                </div>

                <div class="col-md-3">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.SUB_CATEGORY" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.SubRamo}}</span>
                </div>

                <div class="col-md-3" *ngIf="permissionMenu.VerCompania == 1">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.COMPANY" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Aseguradora}}</span>
                </div>
            </div>

            <div class="separator separator-solid separator-border-2 separator-light"></div>

            <div class="row mx-5 my-5">
                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.STATUS" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Estatus}}</span>
                </div>

                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.START_DATE" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.VigenciaDesde | date: 'MM/dd/yyyy' }}</span>
                </div>
                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.DUE_DATE" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.VigenciaHasta | date: 'MM/dd/yyyy'}}</span>
                </div>

                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "PAYMENTS.PAYMENTMODE" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.FormaDePago}}</span>
                </div>
                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "PAYMENTS.PAYMENTCYCLE" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.FrecuenciaDePagos}}</span>
                </div>
                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "PAYMENTS.AMOUNTOFPAYMENTS" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block text-center">{{policy_selected.CantidadDePagos}}</span>
                </div>
            </div>

            <div class="separator separator-solid separator-border-2 separator-light"></div>

            <div class="row mx-5 my-5">
                <div class="col-md-6">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.INSURED" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Asegurado}}</span>
                </div>
                <!-- div class="col-md-4">
                    <span class="font-size-h5 text-light d-block">{{ "MYPROFILE.PERSONID" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Identificacion }}</span>
                </!-->
                <div class="col-md-3">
                    <span class="font-size-h5 text-light d-block"></span>
                    <span class="font-size-h6 font-weight-bold d-block"></span>
                </div>
            </div>

            <div class="separator separator-solid separator-border-2 separator-light"></div>
            
            <div class="row mx-5 my-5">
                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.PRIMA" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block">{{policy_selected.Prima | currency:policy_selected.Divisa }}</span>
                </div>

                <div class="col-md-1">
                    <span class="font-size-h5 text-light d-block">{{ "INSURANCE.DIVISA" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block text-center">{{policy_selected.Divisa }}</span>
                </div>

                <div class="col-md-2">
                    <span class="font-size-h5 text-light d-block" *ngIf="permissionMenu.VerComision == 1">{{ "INPUT.SALESCOMISSION" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block" *ngIf="permissionMenu.VerComision == 1">{{policy_selected.PorcentajeComision}}%</span>
                </div>

                <div class="col-md-2">
                    <span class="font-size-h6 text-light d-block" *ngIf="permissionMenu.VerComisionAgente == 1">{{ "INPUT.AGENTCOMISSION" | translate }}</span>
                    <span class="font-size-h6 font-weight-bold d-block" *ngIf="permissionMenu.VerComisionAgente == 1">{{policy_selected.PorcentajeComisionAgente}}%</span>
                </div>

                <div class="col-md-5 mt-2">
                    <button *ngIf="permissionMenu.VerCondicionesGeneralesPoliza == 1" class="btn btn-primary font-weight-boldest" (click)="downloadPolicyGeneralCondition(loadingModal)"><i class="fa fa-file-alt"></i> {{ "INSURANCE.POLICY_GENERAL_CONDITION" | translate }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="text-light">
                            {{ "INSURANCE.DOCUMENT" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.DOCUMENT_NOMBRE" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.DESCARGA" | translate }}
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let document of documentService.items$ | async; let i = index">
                            <td>{{ document.TipoDocumento }}</td>
                            <td>{{ document.NombreDocumento }}</td>
                            <td><button class="btn btn-link" (click)="clickDownloadDocument(loadingModal, document.IdDocumento, document.NombreDocumento, $event); " ><i class="fas fa-download text-success font-size-h3"></i></button> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div id="view-interest" *ngIf="templateView==3">
    <div class="row mt-5">
        <div class="col-md-9 col-sm-12">
            <h2 class="font-weight-bolder">
                <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "INSURANCE.INSURED_INTEREST" | translate }}
            </h2>
        </div>
        <div class="col-md-3 col-sm-12">
            <button type="button" (click)="clickView(idPoliza, 1)" class="btn btn-lg btn-block btn-default font-uppercase font-weight-bolder">{{ "INPUT.RETURN_TO_LIST" | translate }}</button>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <div class="row mx-5 my-5">
                        <div class="col-md-12"><span class="font-size-h5 text-light">{{ "INSURANCE.CATEGORY" | translate }}</span></div>
                        <div class="col-md-12 mt-2"><span class="font-size-h6 font-weight-bold">{{policy_selected.Ramo}}</span></div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="clearfix"></div>
                    <div class="row mx-5 my-5">
                        <div class="col-md-12"><span class="font-size-h5 text-light">{{ "INSURANCE.NUM_POLICY" | translate }}</span></div>
                        <div class="col-md-12 mt-2"><span class="font-size-h6 font-weight-bold">{{policy_selected.NroDePoliza}}</span></div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12"></div>
            </div>
            <div class="separator separator-solid separator-border-2 separator-light"></div>
            
            <div class="row mx-5 my-5  justify-content-md-center">
                <div class="col-md-10">
                    <form
                    id="interestForm"
                    class="form"
                    [formGroup]="interestForm"
                    novalidate="novalidate"
                    (ngSubmit)="submitFilterInterest()">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group  input-group-lg mb-0">
                                <select class="form-control insured_filter_mode" formControlName="insured_filter_mode" name="insured_filter_mode" (change)="changeFilterMode($event)">
                                    <option value="">{{ "INPUT.FILTER_BY" | translate}}</option>
                                    <option *ngFor="let item of tipoFiltroInteres | async;let i = index" value="{{item.IdTipoFiltroInteres}}">{{item.TipoFiltroInteres}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-0" *ngIf="insuredFilter<2">
                                <div class="input-group input-group-lg">
                                    <input type="text" class="form-control insured_filter_mode_1" formControlName="insured_filter_mode_1"  name="insured_filter_mode_1" placeholder="{{ 'INSURANCE.DESCRIPTION' | translate}}" aria-label=""/>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="flaticon2-search-1 icon-md"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mb-0" *ngIf="insuredFilter==2">
                                <div class="input-group input-group-lg">
                                    <input type="text" class="form-control insured_filter_mode_2" formControlName="insured_filter_mode_2"  name="insured_filter_mode_2" placeholder="{{ 'INSURANCE.NUM_CERTIFICATE' | translate}}" aria-label=""/>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="flaticon2-search-1 icon-md"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mb-0" *ngIf="insuredFilter==3">
                                <div class="input-group input-group-lg">
                                    <select class="form-control insured_filter_mode_3" formControlName="insured_filter_mode_3"  name="insured_filter_mode_3">
                                        <option value="Activo" selected>{{ "INSURANCE.ACTIVE" | translate }}</option>
                                        <option value="Inactivo">{{ "INSURANCE.INACTIVE" | translate }}</option>
                                    </select>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="flaticon2-search-1 icon-md"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group mb-0">
                                <button type="submit" class="btn btn-success btn-lg btn-block">{{ "INPUT.SUBMIT" | translate }}</button>
                            </div>
                        </div>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="text-light">
                            {{ "INSURANCE.INSURED" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.NUM_CERTIFICATE" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.SUMA_ASEGURADA" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.PRIMA" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.STATUS" | translate }}
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let interest of interestService.items$ | async; let i = index">
                            <td><a href="javascript:void(0)" class="text-dark" (click)="onclickModalInteresAsegurado(interestModal, interest, interest.IdPolizaInteres)">{{ interest.Descripcion | slice:0:50}}  <i class="fa fa-ellipsis-h" ></i></a></td>
                            <td>{{ interest.NroCertificado }}</td>
                            <td>{{ interest.SumaAsegurada | currency:"$"}}</td>
                            <td>{{ interest.Prima | currency:"$"}}</td>
                            <td>{{ interest.Estatus }}</td>
                        </tr>
                    </tbody>
                    <tfoot *ngIf(!interestService.items$)>
                        <tr>
                            <td>{{ "INPUT.NO_DATA"}}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div> 
    </div>
</div>

<div style="display: none;"><a href="javascript:void(0)" id="open-pdf" target="_blank"></a></div>

<div class="endosoModal">
    <ng-template #endosoModal let-c="close" let-d="dismiss">
        <form
        [formGroup]="endosoForm"
        novalidate="novalidate"
        enctype="multipart/form-data"
        (ngSubmit)="submitEndoso($event)"
        >
        <div class="modal-header">
            <h4 class="modal-title">{{ "INPUT.GETENDOSO" | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <!-- begin::Alert error-->
                <ng-container *ngIf="endosoHasError">
                    <div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                        <div class="alert-text">{{ "INPUT.ERROR_REQUIRED" | translate }}</div>
                    </div>
                </ng-container>
                <!-- end::Alert error-->

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">{{ "INSURANCE.NUM_POLICY" | translate }}</label>
                            <div class="col-lg-9"><p class="form-control-plaintext bg-secondary text-dark font-weight-boldest rounded pr-1 pl-5">{{ policy_selected.NroDePoliza }}</p></div>
                            <input type="hidden" name="inputIdPoliza" formControlName="inputIdPoliza" />
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">{{ "INSURANCE.ENDOSOTYPE" | translate }}</label>
                            <div class="col-lg-9">
                                <select id="inputIdTipoEndoso" class="form-control" placeholder="" formControlName="inputIdTipoEndoso" name="inputIdTipoEndoso" required 
                                [ngClass]="{ 'is-invalid': endosoForm.controls['inputIdTipoEndoso'].invalid }">
                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                    <option *ngFor="let item of endosos | async" value="{{item.IdTipoEndoso}}">{{item.TipoEndoso}}</option>
                                </select>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: endosoForm.controls['inputIdTipoEndoso']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">{{ "DOCUMENTS.DOCUMENT" | translate }}</label>
                            <div class="col-lg-9">
                                <input type="file" name="file1" formControlName="file1" class="form-control form-file "
                                [ngClass]="{ 'is-invalid': endosoForm.controls['file1'].invalid }">

                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: endosoForm.controls['file1']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">{{ "INPUT.DETAIL" | translate }}</label>
                            <div class="col-lg-9">
                                <textarea name="inputObservacion" formControlName="inputObservacion" class="form-control " rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="modal-footer" >
            <button type="button" class="btn btn-secondary  mr-2" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate }}</button>
            <button type="submit" class="btn btn-success">{{ "INPUT.SUBMIT" | translate }}</button>
        </div>
    </form>
    </ng-template>
</div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<div class="interestModal">
    <span *ngIf="closeResult">
      <pre>{{closeResult}}</pre>
    </span>
    <div>
    <ng-template #interestModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "INSURANCE.INSURED_INTEREST" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row mt-3">
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.INSURED" | translate}}</div>
                <div class="col-9">{{policy_selected.Asegurado}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.SUB_CATEGORY" | translate}}</div>
                <div class="col-9">{{ policy_selected.SubRamo }}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.CERTIFICATE" | translate}}</div>
                <div class="col-9">{{detalleInteresAsegurado.Descripcion}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.NUM_CERTIFICATE" | translate}}</div>
                <div class="col-9">{{detalleInteresAsegurado.NroCertificado}}</div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.HIGH_DATE" | translate}}</div>
                <div class="col-2">{{detalleInteresAsegurado.FechaAlta}}</div>
                <div class="col-2"><i class="fa fa-check text-success"></i></div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.LOW_DATE" | translate}}</div>
                <div class="col-2">{{detalleInteresAsegurado.FechaBaja}}</div>
                <div class="col-2"><i class="fa fa-times text-danger"></i></div>
            </div>

            <div class="row mt-3"> 
                <div class="col-3 font-weight-boldest">{{ "INSURANCE.STATUS" | translate}}</div>
                <div class="col-9" >{{detalleInteresAsegurado.Estatus}}</div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
        </div>
    </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>
